import { getApiKey } from '../../../hooks/useTomTomKey/useTomTomKey';
import { TomTomApiResponse } from '../../../types/TomTom/TomTomApiResponse';
import tomTomApiCall from '../../apiCall/tomTomApi';

class TomTom {
  static fuzzySearch(query: string, signal?: AbortSignal): Promise<TomTomApiResponse> {
    const params = new URLSearchParams();
    params.append('countrySet', 'GB');
    params.append('lat', '53.4069853446936');
    params.append('lon', '-2.9913819854233816');
    params.append('key', getApiKey());

    return tomTomApiCall(
      'GET',
      `search/2/search/${query}.json`,
      params,
      signal,
    ) as Promise<TomTomApiResponse>;
  }
}

export default TomTom;
